/*
  RESADE rs-vergleich.js (E-178, Runde 20, Denny: Vergleich als Tabelle mit Haken und Kreuz wie im Bild, dazu ein Tooltip)
  Nur mit der Darstellung „symbole“ von sections/rs-vergleich.liquid. Jede Zeichenzelle (.rs-vergleich__zelle) hat einen
  Knopf mit dem Namen (rs-nur-sr: Bedeutung und Wert der Zelle) und eine Blase nur fürs Auge (aria-hidden). Maus und
  Tastaturfokus zeigen die Blase per CSS (rs-inhalt-a.css); dieses Skript ergänzt das Tippen, denn iOS fokussiert Knöpfe
  beim Tippen nicht.
  - Tippen oder Klick auf den Knopf schaltet ist-offen; es ist immer nur eine Blase offen.
  - Esc schließt die offene Blase und blendet die unter Fokus oder Maus aus (ist-weg), bis Fokus und Maus die Zelle
    verlassen (WCAG 1.4.13: schließbar, ohne dass der Fokus wandert).
  - Ein Klick daneben schließt; ein Klick in die offene Zelle, auch auf die Blase, lässt sie stehen.
  - Kommt Maus oder Fokus auf eine andere Zelle, schließt die offene, und die Blase der jeweils anderen Zelle weicht.
  Läuft einmal je Seite, auch wenn die Section zweimal steht; Ereignisse am document, so gilt es auch für Sections, die
  der Theme-Editor neu lädt.
*/
(function () {
  'use strict';
  if (window.rsVergleichAn) return;
  window.rsVergleichAn = true;

  var offen = null;
  var ueber = null;

  function zelleVon(el) {
    return el && el.closest ? el.closest('.rs-vergleich__zelle') : null;
  }

  function schliessen() {
    if (offen) offen.classList.remove('ist-offen');
    offen = null;
  }

  function oeffnen(z) {
    if (offen && offen !== z) schliessen();
    z.classList.remove('ist-weg');
    z.classList.add('ist-offen');
    offen = z;
  }

  document.addEventListener('click', function (e) {
    var knopf = e.target && e.target.closest ? e.target.closest('.rs-vergleich__symbol') : null;
    var z = zelleVon(knopf);
    if (z) {
      if (z === offen) {
        // Zweites Tippen schließt, auch wenn die Maus noch darüber steht
        schliessen();
        z.classList.add('ist-weg');
      } else {
        oeffnen(z);
      }
      return;
    }
    if (offen && !offen.contains(e.target)) schliessen();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    var fokus = zelleVon(document.activeElement);
    var liste = [offen, fokus, ueber];
    for (var i = 0; i < liste.length; i++) {
      if (liste[i]) liste[i].classList.add('ist-weg');
    }
    schliessen();
  });

  // Maus und Tastaturfokus auf zwei Zellen: die Blase der anderen weicht (ist-weg), sichtbar bleibt eine
  document.addEventListener('mouseover', function (e) {
    var z = zelleVon(e.target);
    if (z === ueber) return;
    var fokus = zelleVon(document.activeElement);
    if (ueber && ueber !== fokus) ueber.classList.remove('ist-weg');
    ueber = z;
    if (!z) return;
    z.classList.remove('ist-weg');
    if (offen && offen !== z) schliessen();
    if (fokus && fokus !== z) fokus.classList.add('ist-weg');
  });

  document.addEventListener('focusin', function (e) {
    var z = zelleVon(e.target);
    // Nachbesserung E-178: verlässt der Fokus die Zellen, schließt eine getippte Blase (sonst deckt sie Folgendes ab)
    if (!z) {
      if (offen) schliessen();
      return;
    }
    z.classList.remove('ist-weg');
    if (offen && offen !== z) schliessen();
    if (ueber && ueber !== z) ueber.classList.add('ist-weg');
  });

  document.addEventListener('focusout', function (e) {
    var z = zelleVon(e.target);
    if (z && z !== ueber) z.classList.remove('ist-weg');
  });
})();
